import { Navigate, Outlet } from "react-router";

import { useClaims } from "@/hooks/use-claims";

/**
 * Gates the `/admin/*` routes (POS2-1132).
 *
 * Until now those routes sat inside `ProtectedRoute` only, and what kept non-admins out
 * was the sidebar not offering them plus the backend answering 403. That was tolerable
 * while the pages were read-only; the organisations page now carries a write surface, and
 * a screen full of failed requests and an editor that refuses to save is a worse answer
 * than the app the user does have.
 *
 * This is routing correctness, not a security control — every `/admin` endpoint still
 * checks `is_platform_admin` server-side, and that remains the authority. The claim here
 * is read from a token that is up to `jwt_expiry` stale.
 */
export function PlatformAdminRoute() {
  const { isPlatformAdmin } = useClaims();
  return isPlatformAdmin ? <Outlet /> : <Navigate to="/" replace />;
}
